import styled from 'styled-components';

export default styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;



// WEBPACK FOOTER //
// ./src/components/Main/Main.js